import { AllyBase } from "../base";
import { AllyElementBase } from "./ally-element-base.class";

/**
 * --- This class provides part of the function matrix created by the AllyElements object. ---
 * 
 * This class provides functions for all elements.
 * 
 * @extends AllyElementBase
 * @see AllyElements
 */
export class AllyElement extends AllyElementBase {
    /**
     * @param bridge The bridge to the parent in the hierarchical tree.
     * @see AllyBase
     */
    constructor(bridge: () => AllyBase) {
        super(bridge, (matrix) => {
            matrix.push(
                [
                    (scope) => {
                        scope.self.reset();
                    }
                ]
            );
            matrix.push([]);
            matrix.push([]);
        }, 0);
    }
}